import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'player-skip-back', 'PlayerSkipBack', [["path",{"d":"M20 5v14l-12 -7l12 -7"}],["path",{"d":"M4 5l0 14"}]]);